require('./contactInfoBox.scss');

// @ vendors
const React = require('react');
const classNames = require('classnames');
const PropTypes = require('prop-types');

// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const withContactCenterValidation = require('utilities/withContactCenterValidation');


class ContactInfoBox extends React.Component {
    buildButton(label, onClick) {
        return (
            <div className="contact-info-box__button">
                <OKButton modifier="ghost" onClick={onClick}>
                    {label}
                </OKButton>
            </div>
        );
    }

    shouldDisplayBody() {
        const {
            boxBody,
            hasMessage,
            injectedStrings,
        } = this.props;

        const bodyClass = classNames({ 'contact-info-box__text--body' : !hasMessage });

        let bodyText;

        if (typeof bodyText === 'string') {
            bodyText = Array.from(boxBody.split('\n').entries()).map(([key, value]) =>
                (<p key={key}>
                    {value}
                </p>)
            );
        } else if (Array.isArray(boxBody)) {
            const innerList = boxBody.map((listItem, index) =>{
                if (injectedStrings && injectedStrings[listItem]) {
                    return (
                        <li className="contact-info-box__list-item" key={'inner-li-item-' + index}>
                            <FormattedText
                                value={listItem}
                                injectedStrings={injectedStrings[listItem]}
                                className="contact-info-box__list-item-value"
                            />
                        </li>
                    );
                } else {
                    return (
                        <li className="contact-info-box__list-item" key={'inner-li-item-' + index}>
                            <FormattedText
                                value={listItem}
                                className="contact-info-box__list-item-value"
                            />
                        </li>
                    );
                }
            });
            bodyText = (
                <ul className="contact-info-box__list">
                    {innerList}
                </ul>
            );
        } else if (Array.isArray(boxBody)) {
            const innerList = boxBody.map((listItem, index) => (
                <li  className="contact-info-box__list-item" key={'inner-li-item-'+index}>
                    <FormattedText className="contact-info-box__list-item-value" value={listItem} />
                </li>
                ));
            bodyText = (
                <ul className="contact-info-box__list">
                    {innerList}
                </ul>
            );
        } else {
            bodyText = boxBody;
        }

        return !boxBody
            ? ''
            : <div className={bodyClass}>
                {typeof bodyText === 'string' ? <HTMLSafeInjector message={bodyText} /> : bodyText}
            </div>;
    }

    shouldDisplayButton() {
        const { buttonLabel, onClick } = this.props;
        if ('buttonLabel' in this.props) {
            return this.buildButton(buttonLabel, onClick);
        } else {
            return null;
        }
    }

    shouldDisplayLink() {
        const { linkText1, linkText2, linkURL } = this.props;

        return !linkText1 || !linkText2 || !linkURL
            ? null
            : <div className="contact-info-box__text--body">
                {linkText1}{' '}
                <a href={linkURL} target="_blank" className="contact-info-box__text--link">
                    {linkText2}
                </a>.
            </div>;
    }

    render() {
        const { boxTitle, customClass } = this.props;

        let finalClass = classNames('contact-info-box', customClass);
        let headerClass = classNames('contact-info-box__text--header', { 'contact-info-box__text--header-small': this.props.headerSize === 'Small' });

        return (
            <div className={finalClass}>
                <div className="contact-info-box__text">
                    <h1 className={headerClass}>
                        {boxTitle}
                    </h1>
                    {this.shouldDisplayBody()}
                    {this.shouldDisplayButton()}
                    {this.shouldDisplayLink()}
                </div>
            </div>
        );
    }
}

ContactInfoBox.propTypes = {
    boxBody: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array
    ]),
    boxTitle: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string,
    hasMessage: PropTypes.bool,
    linkText1: PropTypes.string,
    linkText2: PropTypes.string,
    linkURL: PropTypes.string,
    headerSize: PropTypes.oneOf(['Big', 'Small']),
    onClick: PropTypes.func,
    customClass: PropTypes.string,
    injectedStrings: PropTypes.object
};

ContactInfoBox.defaultProps = {
    headerSize: 'Big',
    injectedStrings: null
};

module.exports = ContactInfoBox;
module.exports.ContactInfoBoxCCValidated = withContactCenterValidation(ContactInfoBox);

